import TokenView from "components/TokenView"
import { FeaturedProject } from "config"
import useTokenMetadata from "hooks/useTokenMetadata"
import {
  canRenderTokenLive,
  getNftMetadataAspectRatio,
  getNftMetadataGeneratorUrl,
  getNftMetadataImageUrl,
  NftTokenMetadata,
} from "utils/tokenMetadata"

interface Props {
  project?: FeaturedProject
  contractAddress?: string
  chainId?: number
  tokenId: string
  width: number
  fallbackAspectRatio?: number
  invocation?: BigInt | number
  live?: boolean
  showInvocationLink?: boolean
  maxHeight?: number
  metadata?: NftTokenMetadata | null
  metadataLoading?: boolean
  loupe?: boolean
  loupeZoom?: number
}

const MetadataAwareTokenView = ({
  project,
  contractAddress,
  chainId,
  tokenId,
  width,
  fallbackAspectRatio = 1,
  invocation,
  live = false,
  showInvocationLink = false,
  maxHeight,
  metadata,
  metadataLoading,
  loupe = false,
  loupeZoom = 3,
}: Props) => {
  const resolvedContractAddress = project?.contractAddress || contractAddress
  const resolvedChainId = project?.chainId || chainId
  const shouldFetchMetadata = metadata === undefined
  const fetchedMetadata = useTokenMetadata(resolvedContractAddress, tokenId, resolvedChainId, shouldFetchMetadata)
  const nftMetadata = metadata !== undefined ? metadata : fetchedMetadata.data
  const loading = metadataLoading ?? fetchedMetadata.loading
  const invocationValue = typeof invocation === "number" ? BigInt(invocation) : invocation
  const aspectRatio = getNftMetadataAspectRatio(nftMetadata) || fallbackAspectRatio || 1
  const generatorUrl = getNftMetadataGeneratorUrl(nftMetadata)
  const tokenHash = nftMetadata?.token_hash
  const imageUrl = getNftMetadataImageUrl(nftMetadata)
  const shouldRenderLive = live && !loading && canRenderTokenLive(nftMetadata, resolvedChainId)

  if (!resolvedContractAddress) return null

  return (
    <TokenView
      contractAddress={resolvedContractAddress}
      tokenId={tokenId}
      chainId={resolvedChainId}
      width={width}
      invocation={invocationValue}
      aspectRatio={aspectRatio}
      live={shouldRenderLive}
      showInvocationLink={showInvocationLink}
      maxHeight={maxHeight}
      generatorUrl={generatorUrl}
      tokenHash={tokenHash}
      imageUrl={imageUrl}
      isStatic={nftMetadata?.is_static === true}
      alt={nftMetadata?.name}
      loupe={loupe}
      loupeZoom={loupeZoom}
    />
  )
}

export default MetadataAwareTokenView
